import constants from "./constants";
import { updateObject, createReducer } from "../../utils/reduxHelper";

const initialState = {
  getCurrentUserLoading: false,
  getCurrentUserSuccess: false,
  getCurrentUserError: null,
};

/**
 * GetCurrentUser
 */
const getCurrentUserBegin = state =>
  updateObject(state, {
    getCurrentUserLoading: true,
  });

const getCurrentUserSuccess = state =>
  updateObject(state, {
    getCurrentUserLoading: false,
    getCurrentUserError: null,
    getCurrentUserSuccess: true,
  });

const getCurrentUserFailure = (state, action) =>
  updateObject(state, {
    getCurrentUserLoading: false,
    getCurrentUserError: action.payload,
  });

const handlers = {};
handlers[constants.GET_CURRENT_USER_BEGIN] = getCurrentUserBegin;
handlers[constants.GET_CURRENT_USER_SUCCESS] = getCurrentUserSuccess;
handlers[constants.GET_CURRENT_USER_FAILURE] = getCurrentUserFailure;

const menuReducer = createReducer(initialState, handlers);

export default menuReducer;



// WEBPACK FOOTER //
// ./src/modules/menu/reducer.js